import { values } from '../_helpers'

const _enum = {
  low: 0,
  mediumMinus: 1,
  medium: 2,
  mediumPlus: 3,
  high: 4,
}

const acidity = { ..._enum, name: 'acidity', values: values(_enum) }

export {
  acidity
}
